import { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { SelectButton } from "primereact/selectbutton";
import { Button } from "primereact/button";
import CardSeplag from "../../../../components/CardSeplag";
import ModalSeplag from "../../../../components/ModalSeplag";
import RotuloSeplag from "../../../../components/RotuloSeplag";
import { getFormErrorMessage } from "../../../../config/global";
import moment from "moment";
import "./style.css";
import { cadastraCicloExercicio, updateCiclo } from "../../../../service/Monitora/Exercicio";
import ProrrogacaoMonitora from "./ProrrogacaoMonitora";

const ModalMonitoraCiclo = ({
  quantidadeCiclo,
  ciclo,
  exercicio,
  edit,
  setEdit,
  visible,
  setVisible,
  disabled,
  setDisabled,
  show,
  setShow,
  setAtualizaList,
}) => {
  const [showModal, setShowModal] = useState(visible);
  const [form, setForm] = useState(ciclo);
  const toast = useRef(null);
  const [dataFechamentoCicloExercicio, setDataFechamentoCicloExercicio] = useState();
  const [dataFechamentoCicloExercicioGMT, setDataFechamentoCicloExercicioGMT] = useState();
  const [statusCiclo, setStatusCiclo] = useState();
  const [cicloProrrogacao, setCicloProrrogacao] = useState(0);
  const cicloOptions = [
    { option: "Não", code: 0 },
    { option: "Sim", code: 1 },
  ];
  const startForm = () => {
    if (edit) {
      setForm({
        descCiclo: ciclo.descCiclo,
        dataInicio: ciclo.dataInicio,
        dataFim: ciclo.dataFim,
        dataFechamentoCicloExercicio: ciclo.dataFechamentoCicloExercicio,
        qtdeDiasConsolidacao: ciclo.qtdeDiasConsolidacao,
        statusCiclo: ciclo.statusCiclo,
        exercicio: exercicio,
        numrCiclo: quantidadeCiclo,
      });
    }
    if (!edit && !disabled) {
      setForm({
        descCiclo: "",
        dataInicio: "",
        dataFim: "",
        qtdeDiasConsolidacao: "",
        dataFechamentoCicloExercicio: "",
        statusCiclo: "",
        quantidadeCiclo: quantidadeCiclo,
        numrCiclo: quantidadeCiclo,
        exercicio: exercicio,
      });
    }
  };

  useEffect(() => {
    startForm();
  }, []);

  const handleChange = async (_event) => {
    if (formik.values.dataFim !== "" && formik.values.qtdeDiasConsolidacao !== null) {
      formik.values.dataFechamentoCicloExercicio = moment(formik.values.dataFim, "DD/MM/YYYY")
        .add(formik.values.qtdeDiasConsolidacao, "days")
        .format("DD/MM/YYYY");
      setDataFechamentoCicloExercicio(formik.values.dataFechamentoCicloExercicio);
    }

    if (formik.values.dataInicio !== "" && formik.values.dataFim !== "") {
      const nowDate = new Date();
      const dataInicio = new Date(
        Number(formik.values.dataInicio.split("/")[2]),
        Number(formik.values.dataInicio.split("/")[1] - 1),
        Number(formik.values.dataInicio.split("/")[0])
      );
      const dataFim = new Date(
        Number(formik.values.dataFim.split("/")[2]),
        Number(formik.values.dataFim.split("/")[1]) - 1,
        Number(formik.values.dataFim.split("/")[0])
      );
      setDataFechamentoCicloExercicioGMT(
        new Date(
          Number(formik.values.dataFechamentoCicloExercicio.split("/")[2]),
          Number(formik.values.dataFechamentoCicloExercicio.split("/")[1]) - 1,
          Number(formik.values.dataFechamentoCicloExercicio.split("/")[0])
        )
      );
      switch (true) {
        case nowDate < dataInicio:          
          formik.values.statusCiclo = "A INICIAR";
          setStatusCiclo(formik.values.statusCiclo);
          break;
        case nowDate >= dataInicio && nowDate < dataFim:          
          formik.values.statusCiclo = "CICLO ABERTO";
          setStatusCiclo(formik.values.statusCiclo);
          break;
        case nowDate > dataFim && nowDate <= dataFechamentoCicloExercicioGMT:
          formik.values.statusCiclo = "EM CONSOLIDAÇÃO";
          setStatusCiclo(formik.values.statusCiclo);
          break;
        case nowDate > dataFechamentoCicloExercicioGMT:
          formik.values.statusCiclo = "CICLO FECHADO";  //realiza alteracao de Fechado para Ciclo fechado
          setStatusCiclo(formik.values.statusCiclo);
          break;
        default:
          formik.values.statusCiclo = "";
          setStatusCiclo(formik.values.statusCiclo);
      }
    }
  };

  const statusEnum = (data) => {
    switch (true) {
      case data === "EM CONSOLIDAÇÃO":
        return "CONSOLIDACAO";
      default:
        return data;
    }
  };

  const statusEnumNumber = (status) => {    
    switch (true) {
      case status === "A INICIAR"://"PENDENTE":
        return 0;
      case status === "CICLO ABERTO"://"ABERTO":
        return 1;
      case status === "ESTRATEGICO":
        return 2;
      case status === "EM CONSOLIDAÇÃO"://"CONSOLIDAÇÃO":        
        return 3;      
      default:  //qq outra situacao serah Fechado        
        return 4;
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,

    validate: (data) => {
      let errors = {};
      if (!data.descCiclo) errors.descCiclo = "O campo 'Descrição' deve ser informado";
      if (!data.dataInicio) errors.dataInicio = "O campo 'Data Inicial' deve ser informado";
      if (!data.dataFim) errors.dataFim = "O campo 'Data Final' deve ser informado";
      if (!data.qtdeDiasConsolidacao || data.qtdeDiasConsolidacao < 1)
        errors.qtdeDiasConsolidacao = "O campo 'Dias para Consolidação' deve ser informado";
      return errors;
    },

    onSubmit: async (data) => {
      let createCicloDTO = { ...data };

      if (edit) {
        let jsonPost = { ...ciclo };
        jsonPost.descCiclo = data.descCiclo;
        jsonPost.dataInicio = data.dataInicio;
        jsonPost.dataFim = data.dataFim;
        jsonPost.qtdeDiasConsolidacao = data.qtdeDiasConsolidacao;
        jsonPost.numrCiclo = "1";
        jsonPost.dataFechamentoCicloExercicio = data.dataFechamentoCicloExercicio;
        jsonPost.statusCiclo = statusEnumNumber(data.statusCiclo);        
        createCicloDTO.acaoLista = "SOBRESCREVER";

        await updateCiclo(jsonPost.idenCiclo, jsonPost).then((_res) => {
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
          setVisible(false);
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setShow(false);
          setAtualizaList(true);
        });
      }
      if (!edit) {
        createCicloDTO.statusCiclo = statusEnumNumber(data.statusCiclo);        
        createCicloDTO.quantidadeCiclo = 1;
        createCicloDTO.numrCiclo = 1;
        createCicloDTO.acaoLista = "SOBRESCREVER";

        await cadastraCicloExercicio(createCicloDTO).then((_res) => {
          window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });
          setVisible(false);
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setShow(false);
          setAtualizaList(true);
        });
      }
    },
  });

  const header = () => {
    if (edit) {
      return `Editar  ${ciclo.descCiclo}`;
    }
    if (show) {
      return `${ciclo.descCiclo}`;
    }
    return "MONITORAMENTO: CICLO DE MONITORAMENTO";
  };

  return (
    <ModalSeplag
      titulo={header}
      tamanho="1200px"
      visible={showModal}
      fechar={() => {
        setVisible(false);
        setShowModal(false);
        setEdit(false);
        setDisabled(false);
        setShow(false);
      }}
      type="NONE"
    >
      <Toast ref={toast} />
      <CardSeplag>
        <form onSubmit={formik.handleSubmit}>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-12 ">
              <div className="p-fluid grid">
                <div className="field col-12 md:col-12 ">
                  <RotuloSeplag nome={"Descrição:"} cols="12 12">
                    <InputText
                      disabled={disabled}
                      id="descCiclo"
                      value={formik.values.descCiclo}
                      onChange={formik.handleChange}
                      onBlur={handleChange}
                    />
                    {getFormErrorMessage("descCiclo", formik)}
                  </RotuloSeplag>
                </div>
              </div>
              <div className="p-fluid grid">
                <div className="field col-12 md:col-3 ">
                  <RotuloSeplag nome="Data Inicial:" cols="12 3">
                    <InputMask
                      disabled={disabled}
                      mask="99/99/9999"
                      id="dataInicio"
                      value={formik.values.dataInicio}
                      onChange={formik.handleChange}
                      onKeyUp={handleChange}
                    />
                    {getFormErrorMessage("dataInicio", formik)}
                  </RotuloSeplag>
                </div>
                <div className="field col-12 md:col-3">
                  <RotuloSeplag nome="Data Final:" cols="12 3">
                    <InputMask
                      disabled={disabled}
                      mask="99/99/9999"
                      id="dataFim"
                      value={formik.values.dataFim}
                      onChange={formik.handleChange}
                      onKeyUp={handleChange}
                    />
                    {getFormErrorMessage("dataFim", formik)}
                  </RotuloSeplag>
                </div>
                <div className="field col-12 md:col-3">
                  <RotuloSeplag nome="Dias para Consolidação:" cols="12 4">
                    <InputText
                      disabled={disabled}
                      id="qtdeDiasConsolidacao"
                      tooltip="Quantidades de Dias para Consolidação:"
                      keyfilter={"pint"}
                      value={formik.values.qtdeDiasConsolidacao}
                      onChange={formik.handleChange}
                      onKeyUp={handleChange}
                    />
                    {getFormErrorMessage("qtdeDiasConsolidacao", formik)}
                  </RotuloSeplag>
                </div>
                <div className="field col-12 md:col-3">
                  <RotuloSeplag nome="Data de Encerramento:" cols="12 3">
                    <InputText
                      disabled={true}
                      id="dataFechamentoCicloExercicio"
                      value={dataFechamentoCicloExercicio || formik.values.dataFechamentoCicloExercicio}
                    />
                  </RotuloSeplag>
                </div>
              </div>
              <div className="p-fluid grid">
                <div className="field col-12 md:col-4">
                  <RotuloSeplag nome="Status:" cols="12 4">
                    <InputText disabled={true} id="statusCiclo" value={statusCiclo || formik.values.statusCiclo} />
                  </RotuloSeplag>
                </div>
                <div className="field col-12 md:col-4">
                  <RotuloSeplag nome="Ciclo de Prorrogação:" cols="12 4">
                    <SelectButton
                      id="code"
                      optionLabel="option"
                      optionValue="code"
                      value={cicloProrrogacao}
                      options={cicloOptions}
                      onChange={(e) => {
                        setCicloProrrogacao(e.value);
                      }}
                    ></SelectButton>
                  </RotuloSeplag>
                </div>
              </div>
            </div>
          </div>
          {cicloProrrogacao === 1 && <ProrrogacaoMonitora exercicio={exercicio} />}
          <div className="field col-12 md:col-4">
            <RotuloSeplag cols="12 4">
              {!edit && !disabled && (
                <Button type="submit" icon="pi pi-check" label="Criar" className="p-button-info"></Button>
              )}
              {edit && (
                <Button
                  type="submit"
                  icon="pi pi-pi pi-user-edit p-button-icon p-button-icon-left"
                  label="Salvar"
                  className="p-button-warning p-button p-component"
                  style={{ fontSize: "16px" }}
                ></Button>
              )}
            </RotuloSeplag>
          </div>
        </form>
      </CardSeplag>
    </ModalSeplag>
  );
};
export default ModalMonitoraCiclo;
